// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"card_wrapper__1MFHC","user":"card_user__z0apk","date":"card_date__1Wxr3","hand":"card_hand__NQTmE","score":"card_score__1G92j","words":"card_words__3KLuY"};